import classNames from 'classnames';

import styles from './styles.module.scss';

export const listEditModeWrapperClassnames = classNames([styles[`list-edit-mode`]]);
